import { useQuery } from '@tanstack/react-query';
import { rateApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry The job's rate sheet (labor, equipment and material rates). */
export function useJobRates(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.rates.forJob(jobId ?? -1),
    queryFn: ({ signal }) =>
      rateApiClient.getRatesByJob(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    staleTime: 60_000,
    meta: { errorContext: 'job rates' },
  });
}
